import React from 'react';
import './GeneralDocs.css'; 

const TrainGestures = () => {
  return (
    <div className="docs-page-container">
      <h1>Training Gestures</h1>
      <p>
        When you enter the Train Gestures menu, you will see two sections: <strong>Train a Gesture</strong> and <strong>Train Face Recognition</strong>.
      </p>

      <h2>Train a Gesture</h2>
      <p>
        Click on <strong>New Gesture</strong> to create your first gesture. You can then select the amount of seconds to record the gesture and
        start recording.
      </p>
      <p>
        Once the recording starts, The border of the recording will go green. To properly record a gesture, keep the gesture as long as the green border
        stays. 
      </p>
      {/* video starts with train gesture screen, click new gesture, and record gesture 1 */}
      <video className="tutorial-video" controls muted={false} disablePictureInPicture controlsList="nodownload nofullscreen noplaybackrate">
        <source src="/videos/train_gesture.mp4" type="video/mp4" />
          Your browser does not support the video tag.
      </video>

      <h2>Face Recognition</h2>
      <p> 
        In order for the AI model to learn to recognize a gesture, it also needs to know when you are not doing any. 
        This section is essential for the correct implementation of the AI model.
      </p>
      <p>
        To train Face Recognition, click on the square to go to the recoding section. When recording, just
        keep a relaxed pose. 
      </p>
      <video className="tutorial-video" controls muted={false} disablePictureInPicture controlsList="nodownload nofullscreen noplaybackrate">
          <source src="/videos/train_face_recognition.mp4" type="video/mp4" />
          Your browser does not support the video tag.
      </video>

      <h2>Considerations when training</h2>
      <ul>
        <li> <strong> Wrong data will drastically affect predictions: </strong>
        While the border of the recording is green, be sure to maintain the gesture. Doing another gesture or change to a relaxed pose will affect the
        performance of the model. 
        </li>
        <li>
          <strong>More data, better performance:</strong> If there is a particular gesture or scenario where the AI model does not perform
          correctly, more training on it may solve the issue. 
        </li>
        <li>
          <strong>Train the gestures in the same scenarios where you will use FaceLead:</strong> The place you use to train the gestures may have
          specific characteristics such as light and shadows, and these can affect the AI model's performance. If you primarily use
          FaceLead at a specific location, like your desk, it is highly recommended to train your gestures in that location. Be aware that small changes in
          conditions, such as light changes, may also impact performance. Training gestures under different conditions can help address this issue.
        </li>
        <li>
          <strong>Lateral light and asymmetric gestures:</strong> Asymmetric gestures (e.g., moving your mouth to the right or your cheek to the left)
          generally suffer from lower performance when the lighting angle in the room differs from the one during training. Training asymmetric gestures
          under various lighting setups can often resolve this issue.
        </li>
      </ul>
    </div>
  );
};

export default TrainGestures;
